module.exports = __webpack_public_path__ + "img/8_r.5f798b04.jpg";